import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'itl-text-chip-bar',
  templateUrl: './text-chip-bar.component.html',
  styleUrls: ['./text-chip-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TextChipBarComponent {}
